import { GET_PHOTO_COLLECTION, MARK_PHOTO_SENT } from '../endpoints'
import request from '../request'

export const getPhotoCollection = async(conversationUid, photoCategoryId) => {
  const params = { conversationUid }
  if (photoCategoryId != null) {
    params.photoCategoryId = photoCategoryId
  }
  const { result } = await request.get(GET_PHOTO_COLLECTION, params)
  return result
}

export const markPhotoSent = (conversationUid, photoId) => {
  return request.post(MARK_PHOTO_SENT, { conversationUid, photoId })
}
